import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import { ChevronDown } from "lucide-react";

export const FAQ = () => {
  const { t } = useTranslation();
  const faqItems = t('faq.items', { returnObjects: true });
  const [openIndex, setOpenIndex] = useState(null);

  // Generate FAQ Schema.org JSON-LD
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqItems.map(item => ({
      "@type": "Question",
      "name": item.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.answer
      }
    }))
  };

  return (
    <section 
      id="faq" 
      className="py-20 bg-stone-50"
      data-testid="faq-section"
    >
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      </Helmet>
      
      <div className="max-w-3xl mx-auto px-6">
        {/* Headline */}
        <h2 
          className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-stone-900 text-center mb-12"
          style={{ fontFamily: 'Outfit, sans-serif' }}
          data-testid="faq-headline"
        >
          {t('faq.headline')}
        </h2>
        
        {/* FAQ Accordion */}
        <div className="space-y-3">
          {faqItems.map((item, index) => (
            <div 
              key={index} 
              className="bg-white rounded-xl border border-stone-200 overflow-hidden"
              data-testid={`faq-item-${index}`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-5 text-left hover:bg-stone-50 transition-colors"
                aria-expanded={openIndex === index}
              >
                <span className="font-medium text-stone-900 pr-4">
                  {item.question}
                </span>
                <ChevronDown 
                  className={`w-5 h-5 text-stone-400 flex-shrink-0 transition-transform ${
                    openIndex === index ? 'rotate-180' : ''
                  }`} 
                />
              </button>
              {openIndex === index && (
                <div className="px-5 pb-5 pt-0">
                  <p className="text-stone-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
